import { deliveryUnitAPI } from "../../axios";

export const actions = {

    //Realignment
    GetRealignmentItem(context, data){
        return deliveryUnitAPI.get(`RealignmentRequestItem/RealignmentRequest/${data}`);
    },
    GetPendingRealignmentItem(context, data){
        return deliveryUnitAPI.get(`RealignmentRequestItem/Pending/${data.deliveryUnitId}/${data.cycle}`);
    },
    GetPendingRealignmentItemByDep(context, data){
        return deliveryUnitAPI.get(`RealignmentRequestItem/Pending/Department/${data.departmentId}/${data.cycle}`);
    },
    UpdateRealignment(context, data){
        return deliveryUnitAPI.put(`RealignmentRequestItem/Update/${data.id}`, data);
    },
    DeleteRealignment(context, data){
        return deliveryUnitAPI.delete(`RealignmentRequestItem/Remove/${data}`);
    },
    CreateRealignment(context, data){
        return deliveryUnitAPI.post(`RealignmentRequestItem/Create/${data.cycle}/${data.deliveryUnitId}`, data);
    },
    AddRealignment(context, data){
        return deliveryUnitAPI.post(`RealignmentRequestItem/Add/${data.realignmentRequestItemId}`, data);
    },
    GetAvailableRealignmentItem(context, data){
        return deliveryUnitAPI.get(`RealignmentRequestItem/Available/ApiResourceDetails/${data}`);
    },
}